import React from 'react';
import '../Css_files/Homecont1.css';

const HomeContent1 = () => {
  const items = [
    {
      title: "Expert-Led Courses",
      text: "Learn directly from industry professionals and certified trainers who guide you with real-world insights and projects.",
      icon: "👨‍🏫"
    },
    {
      title: "Practical & Hands-On Learning",
      text: "Every course includes projects, case studies, and practice exercises so you gain job-ready skills, not just theory.",
      icon: "💻"
    },
    {
      title: "Flexible Learning",
      text: "Study at your own pace with flexible schedules, recorded sessions, and lifetime access to learning materials.",
      icon: "⏰"
    },
    {
      title: "Affordable & Value-Packed",
      text: "High-quality training at affordable prices, making professional upskilling accessible to everyone.",
      icon: "💰"
    },
    {
      title: "Dedicated Support",
      text: "Get assistance whenever you need — from technical help to learning guidance — ensuring a smooth journey.",
      icon: "🖥️"
    },
    {
      title: "Career Guidance",
      text: "We provide interview preparation, resume building, and career counseling to help you land your dream job.",
      icon: "📘"
    }
  ];

  return (
    <div className="homecontent1-wrapper">
      <div className="homecontent1-heading">
        <h2>
          Why <span>Choose Profenaa?</span>
        </h2>
        <p>
          At <strong>Profenaa Technologies Online Learning</strong>, we believe education should be practical, flexible, and career-focused. 
          With expert-led sessions, real-world projects, and strong career support, we help learners transform knowledge into success. 
          Whether you are a student or a working professional, we provide the right tools and guidance to accelerate your growth.
        </p>
      </div>

      <div className="homecontent1-container">
        {items.map((item, index) => (
          <div className="content-box1" key={index}>
            <div className="icon1">{item.icon}</div>
            <h3>{item.title}</h3>
            <p>{item.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HomeContent1;
